import React, { useCallback, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import debounce from 'debounce';
import { InputText } from 'components/_new/InputText';
import { useLocation } from 'react-router-dom';
import { useKnowledgeBase } from './knowledgeBaseContext';

export const SearchBar = () => {
	const { t } = useTranslation();
	const location = useLocation();
	const { onSearch, searchValue } = useKnowledgeBase();
	const inputRef = useRef<HTMLInputElement>(null);

	useEffect(() => {
		onSearch('');
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [location]);

	useEffect(() => {
		if (inputRef?.current && (!searchValue || searchValue?.length === 0)) {
			inputRef.current.value = '';
		}
	}, [searchValue]);

	// eslint-disable-next-line react-hooks/exhaustive-deps
	const onSearchDebounced = useCallback(
		debounce((searchQuery: string) => {
			onSearch(searchQuery);
		}, 500),
		[onSearch]
	);

	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const { value } = event.target;
		onSearchDebounced(value);
	};

	const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
		if (event.key === 'Enter' && event.currentTarget.value.length > 0) {
			onSearch(event.currentTarget.value);
		}
	};

	return (
		<div className="flex sm:flex-row flex-column justify-content-between gap-1">
			<span className="w-full p-input-icon-left">
				<i className="pi pi-search" />

				<InputText
					ref={inputRef}
					type="search"
					defaultValue={searchValue || ''}
					onChange={handleChange}
					onKeyDown={handleKeyDown}
					placeholder={t('knowledgeBase.searchbarPlaceholder')}
					className="w-full pl-5"
				/>
			</span>
		</div>
	);
};
